import React, { useRef, useEffect, useState } from "react";
import { useKpiComparison } from "../../../hooks/useKpiComparison.js";
import "./KpiChart.scss";

export const KpiChart = ({
  metadata = {},
  data = [],
  auxComparisonData = null,
}) => {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [showIcon, setShowIcon] = useState(true);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const resize = () => {
      const w = el.offsetWidth;
      const h = el.offsetHeight;
      const min = 0.7;
      const max = 2.2;
      const base = Math.min(w, h);
      let newScale = base / 180;
      newScale = Math.max(min, Math.min(max, newScale));
      setScale(newScale);
      setShowIcon(!(h <= 100));
    };
    resize();
    const observer = new window.ResizeObserver(resize);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  // Extraer info principal (sin modificar - código de tu compañero)
  const valueColumn = metadata.kpiPanelValueColumns?.[0];
  const title = metadata?.kpiPanelDef?.title || "";
  const columnName = valueColumn?.columnName || "";
  const iconName = valueColumn?.iconName;
  const fontColor = valueColumn?.fontColor || "#585255";
  const iconColor = valueColumn?.iconColor || "#585255";
  const staticPrefix = valueColumn?.staticPrefix || "";
  const staticSuffix = valueColumn?.staticSuffix || "";
  const value = data?.[0]?.[columnName] ?? "-";

  // ✅ RENOMBRAR VARIABLE para evitar conflicto
  const comparisonResult = useKpiComparison(
    metadata,
    value,
    staticSuffix,
    data,
    auxComparisonData,
    staticPrefix
  );

  return (
    <div className="kpi-chart-container" ref={containerRef}>
      {iconName && showIcon && (
        <span
          className={`kpi-chart-icon icon-${iconName}`}
          style={{ color: iconColor, fontSize: `${2 * scale}rem` }}
        />
      )}
      <div
        className="kpi-chart-value"
        style={{ color: fontColor, fontSize: `${1.2 * scale}rem` }}
      >
        {staticPrefix && <span className="kpi-prefix">{staticPrefix}</span>}
        <span className="kpi-main-value">{value}</span>
        {staticSuffix && <span className="kpi-suffix">{staticSuffix}</span>}
      </div>
      <div
        className="kpi-chart-label"
        style={{ fontSize: `${0.7 * scale}rem` }}
      >
        {title}
      </div>
      {comparisonResult && (
        <div
          className="kpi-comparison-container"
          style={{ fontSize: `${0.6 * scale}rem` }}
        >
          {comparisonResult.showPercentage && (
            <div
              className="kpi-comparison-value"
              style={{ color: comparisonResult.color }}
            >
              <span
                className={`kpi-comparison-icon ${comparisonResult.icon}`}
              />
              <span className="kpi-comparison-difference">
                {comparisonResult.difference}
              </span>
            </div>
          )}
          <div className="kpi-comparison-info">
            <span className="kpi-comparison-label">
              {comparisonResult.label}:
            </span>
            <span className="kpi-comparison-value-amount">
              {comparisonResult.valueToCompare}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

/*
  .kpi-chart-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: clamp(0.5rem, 2vw, 2rem);
    box-sizing: border-box;
  }
  .kpi-chart-icon {
    font-size: clamp(1.5rem, 8vw, 5rem);
    margin-bottom: clamp(0.2rem, 1vw, 1rem);
  }
  .kpi-chart-value {
    font-size: clamp(1.2rem, 6vw, 3rem);
    font-weight: bold;
    margin-bottom: clamp(0.1rem, 0.8vw, 0.8rem);
  }
  .kpi-chart-title {
    font-size: clamp(0.8rem, 3vw, 1.5rem);
    color: #646978;
    text-align: center;
  }
  */
